import React from 'react'
import './ErrorMessages.css'

const ErrorMessages = (props) => {
  if(!props.message){
    return null;
  }
  return (
    <div className="error-text">{props.message}</div>
  )
}

export default ErrorMessages
